<template>
	<v-alert
		border="left"
		:type="type"
		@input="onInput"
		:dismissible="dismissible"
	>
	{{ message }}
	</v-alert>
</template>

<script>
export default {
	props: {
		type: String,
		message: String,
		dismissible: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		onInput(event) {
			if (!event) {
				this.$emit('close')
			}
		},
	},
}
</script>
